import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

// ─── Prompt Template Types ────────────────────────────────────────────────────

export const createPromptTemplateType = async ({ name, description = null }) => {
  const URL = `${BASE_URL}promptTemplates/types`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ name, description }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const getPromptTemplateTypes = () => {
  const URL = `${BASE_URL}promptTemplates/types`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((res) => res.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const updatePromptTemplateType = async ({ id, name, description }) => {
  const URL = `${BASE_URL}promptTemplates/types`

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ id, name, description }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const deletePromptTemplateType = async (id) => {
  const URL = `${BASE_URL}promptTemplates/types?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

// ─── Prompt Templates ─────────────────────────────────────────────────────────

export const createPromptTemplate = async ({ name, text }) => {
  const URL = `${BASE_URL}promptTemplates`

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ name, text }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const getPromptTemplates = ({ page = 0, name = '' } = {}) => {
  const URL = `${BASE_URL}promptTemplates?page=${page}&name=${name}&type`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((res) => res.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}

export const updatePromptTemplate = async ({ id, name, text }) => {
  const URL = `${BASE_URL}promptTemplates`

  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: JSON.stringify({ id, name, text }),
    })
    return response
  } catch (error) {
    console.log(error)
  }
}

export const deletePromptTemplate = async (id) => {
  const URL = `${BASE_URL}promptTemplates?id=${id}`

  try {
    const response = await fetch(URL, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
    return response
  } catch (error) {
    console.log(error)
  }
}
